import { useId } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CONF } from "@/lib/fit";
import { CountUp, EASE } from "@/components/motion/Motion";

export function FitDial({ score, confidence, size = 188, testId = "fit-dial", label = "Fit Score", provisional = false }) {
  const gid = useId().replace(/:/g, "");
  const reduce = useReducedMotion();
  const stroke = Math.max(6, size * 0.07);
  const r = (size - stroke) / 2 - 2;
  const c = size / 2;
  const pct = score == null ? 0 : Math.max(0, Math.min(1, score / 10));
  return (
    <div data-testid={testId} className="relative inline-flex shrink-0 flex-col items-center" style={{ width: size }}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }} aria-hidden="true">
          <defs><linearGradient id={gid} x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#1F4D3A" /><stop offset="100%" stopColor="#1F4D3A" /></linearGradient></defs>
          <circle cx={c} cy={c} r={r} fill="none" stroke="#E6EEE8" strokeWidth={stroke} />
          {score != null && (
            <motion.circle cx={c} cy={c} r={r} fill="none" stroke={`url(#${gid})`} strokeWidth={stroke} strokeLinecap="round"
              initial={{ pathLength: reduce ? pct : 0 }} animate={{ pathLength: pct }} transition={{ duration: reduce ? 0 : 0.9, ease: EASE }}
              style={{ opacity: provisional ? 0.6 : 1 }} />
          )}
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <CountUp value={score} decimals={1} className="font-display font-semibold leading-none tracking-tight text-ink tabular-nums" style={{ fontSize: size * 0.24 }} testId={`${testId}-value`} />
          <span className="mt-1 font-medium uppercase tracking-[0.14em] text-ink-muted" style={{ fontSize: Math.max(9, size * 0.055) }}>{label}</span>
        </div>
      </div>
      {provisional && score != null && (
        <span className="mt-2 rounded-full border border-[#E8D7B0] bg-caution-tint px-2 py-0.5 text-[11px] font-semibold text-caution" data-testid={`${testId}-provisional`}>Provisional</span>
      )}
      {confidence && !provisional && <span className="mt-2 rounded-full bg-[#F3EEE3] px-2.5 py-0.5 text-[11px] font-medium text-[#7A5300]" data-testid={`${testId}-confidence`}>{CONF[confidence]}</span>}
    </div>
  );
}
